// Centralised API client
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 25000,
});

export const fetchSiteInfo = () => api.get("/site-info").then((r) => r.data);
export const fetchSliders = () => api.get("/sliders").then((r) => r.data);
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchCategory = (slug) => api.get(`/categories/${slug}`).then((r) => r.data);
export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchBlogList = (params = {}) => api.get("/blog", { params }).then((r) => r.data);
export const fetchBlog = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);
export const fetchClients = () => api.get("/clients").then((r) => r.data);
export const fetchManufacturing = () => api.get("/manufacturing-unit").then((r) => r.data);
export const fetchAbout = () => api.get("/about").then((r) => r.data);

export const postEnquiry = (body) => api.post("/enquiry", body).then((r) => r.data);
export const postSubscribe = (body) => api.post("/subscribe", body).then((r) => r.data);
export const postFranchise = (body) => api.post("/franchise-apply", body).then((r) => r.data);

export default api;
